import { defineNuxtPlugin, provideGlobalConfig } from '#imports';

export default defineNuxtPlugin(nuxtApp => { 
  provideGlobalConfig({"size":"large","zIndex":2000}, nuxtApp.vueApp, true);
})